import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css';

// Custom styles
import './assets/css/main.css';

// Axios configuration
import axios from 'axios';

// Set default axios configurations
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'https://n98cpw2fo7.execute-api.ap-south-1.amazonaws.com/dev';
axios.defaults.timeout = 30000;

// Add request interceptor to include auth token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Remove invalid token and redirect to appropriate login
      const userType = localStorage.getItem('userType');
      store.dispatch('auth/logout');

      if (userType === 'admin') {
        if (router.currentRoute.value.name !== 'AdminLogin') {
          router.push('/admin/login');
        }
      } else {
        if (router.currentRoute.value.name !== 'MobileOnlyLogin') {
          router.push('/login');
        }
      }
    }
    return Promise.reject(error);
  }
);

// Create Vue app
const app = createApp(App);

// Make axios available globally
app.config.globalProperties.$http = axios;

app.use(store)
   .use(router)
   .mount('#app');
